import React from 'react';

export function PrivacyPolicy () {
  return (
    <p>Aviso de Privacidad</p>
  )
}